export default "__VITE_ASSET__CPmrBgGu__"